import type { ResponseWithType, EventProgress, EventProgressRest } from './types';

const eventProgress = ({ data }: ResponseWithType<EventProgressRest>): EventProgress => {
  const { id, races } = data;
  return {
    __typename: 'EventProgress',
    id,
    races: races.filter(({ stats }) => !!stats),
  };
};

export default eventProgress;
